// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1ni0x","author":"Table_author__17pUV","authorImage":"Table_authorImage__Cefez","unreadRow":"Table_unreadRow__1y7hC"};